import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function postJSON(path, body) {
  const { data } = await axios.post(`${API_BASE}${path}`, body, { timeout: 20000 });
  return data;
}
